/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

const styles = {
  root: css`
    margin: var(--cds-spacing-200) 0;
    word-wrap: break-word;

    svg {
      flex-shrink: 0;
    }

    &:focus {
      outline: none;
    }
  `,
};

type Props = {
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

/** Simple wrapper for other chat components with common styling like margin */
export const ChatMessageContainer = React.forwardRef((props: Props, ref: React.Ref<HTMLDivElement>) => {
  const { children, className, ...rest } = props;

  return (
    <div className={classNames('coach-chat-message-container', className)} css={styles.root} ref={ref} {...rest}>
      {children}
    </div>
  );
});

export default ChatMessageContainer;
